module.exports = __webpack_public_path__ + "media/images/country_flags/yt-20c82e1348a4ed53977e17aa414f4af9.png";